import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";
import { concatPathWithParams } from "../api/apiHelper";

const operatorDashboardAdapter = createEntityAdapter();

const initialState = operatorDashboardAdapter.getInitialState();

export const operatorDashboardAPISlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
          getDSMMeters: builder.query({
            query: (queryParams) => concatPathWithParams("/dsm/meters/", queryParams),
            providesTags: ["dsm_meters"],
          }),

        getDSMMeterFindPage: builder.query({
            query: (params) => concatPathWithParams("/dsm/meters/find-page/", params),
        }),

        getLSPSState: builder.query({
            query: () => "/dsm/lspsstate/",
            providesTags: ["lsps_state"],
        }),

        updateLSPSState: builder.mutation({
            query: (request) => ({
                url: `/dsm/lspsstate/`,
                body: request.body,
                method: "PATCH",
            }),
            invalidatesTags: ["lsps_state"],
        }),

        getDashboardStatus: builder.query({
            query: (timezone) =>
                `/dsm/operator-dashboard-status/?timezone=${timezone}`,
            providesTags: ["lsps_state"],
        }),

        getMicroServiceMonitoring: builder.query({
            query: () => "/dsm/microservice-monitoring/",
            providesTags: ["graph"],
        }),

        getMicroServiceMonitoringForcast: builder.query({
            query: () => "/dsm/microservice-monitoring-forcast/",
            providesTags: ["graph"],
        }),
        getTargetDataNow: builder.query({
            query: () => "/dsm/target-data-now/",
            providesTags: ["graph"],
        }),
        getTotalInstalledCapacity: builder.query({
            query: () => `/dsm/total-installed-capacity/`,
            providesTags: ["total_installed_capacity"],
        }),

        getMicroServiceMonitoringGraphData: builder.query({
            query: (request) =>
                concatPathWithParams(
                    `dsm/microservice-monitoring/graph/`,
                    request.queryParams,
                ),
            providesTags: ["graph"],
        }),
        resetGeysers: builder.mutation({
          query: (request) => ({
            url: `/dsm/geyser-emergency-on/`,
            body: request.body,
            method: "POST",
          }),
          invalidatesTags: ["dsm_meters"],
        }),

        updateDeviceForcedStatus: builder.mutation({
          query: (body) => ({
            url: `/dsm/meters/forced-status/`,
            body,
            method: "POST",
          }),
          invalidatesTags: ["dsm_meters", "active_session"],
        }),

        getActiveSession: builder.query({
          query: () => `/dsm/meters/forced-status/`,
          providesTags: ["active_session"],
        }),

        getSwitchingHistory: builder.query({
          query: ({ limit = 20 } = {}) => `/dsm/meters/switching-history/?limit=${limit}`,
          providesTags: ["switching_history"],
        }),

        getHWIGraph: builder.query({
          query: (request) => {
            let url = `/dsm/operator-dashboard/hot-water-index/${request.meter_id}/?timezone=${request.timezone}`;
            if (request.start_date) {
              url += `&start_date=${request.start_date}`;
            }
            return url;
          },
          providesTags: ["hwi_graph"],
        }),
        getHWITable: builder.query({
          query: ({ meter_id, userTimezone, start_date }) => {
            let url = `/dsm/operator-dashboard/hot-water-index/meter/${meter_id}/?userTimeZone=${userTimezone}`;
            if (start_date) {
              url += `&start_date=${start_date}`;
            }
            return url;
          },
          providesTags: ["hwi_table"],
        }),


        getADPGraph: builder.query({
          query: (queryParams) => concatPathWithParams("/dsm/adp-graph/", queryParams),
          providesTags: ["adp_graph"],
        }),

        getADPPeakSummary: builder.query({
          query: () => "/dsm/adp-peak-summary/",
          providesTags: ["adp_peak_summary"],
        }),

        // getEnergyGraph: builder.query({
        //   query: (request) =>
        //     `/dsm/municipality-dashboard/?start_date=${request.start_date}&end_date=${request.end_date}&user-timezone=${request.user_timezone}`,
        //   providesTags: ["energy_graph"],
        // }),

        // getEnergyValues: builder.query({
        //   query: (request) =>
        //     `/dsm/municipality-dashboard/values/?start_date=${request.start_date}&end_date=${request.end_date}&user-timezone=${request.user_timezone}`,
        //   providesTags: ["energy_values"],
        // }),
    }),
});

export const {
    useGetLSPSStateQuery,
    useGetDSMMetersQuery,
    useGetDSMMeterFindPageQuery,
    useGetDashboardStatusQuery,
    useGetMicroServiceMonitoringQuery,
    useGetMicroServiceMonitoringForcastQuery,
    useGetTargetDataNowQuery,
    useGetTotalInstalledCapacityQuery,
    useGetMicroServiceMonitoringGraphDataQuery,
    useUpdateLSPSStateMutation,
    useGetHWIGraphQuery,
    useGetHWITableQuery,
    useGetEnergyGraphQuery,
    useGetEnergyValuesQuery,
    useResetGeysersMutation,
    useUpdateDeviceForcedStatusMutation,
    useGetActiveSessionQuery,
    useGetSwitchingHistoryQuery,
    useGetADPGraphQuery,
    useGetADPPeakSummaryQuery,
} = operatorDashboardAPISlice;
